export const i18nContentHash = '4c14037'
